import React, { useEffect, useState } from 'react';
import { fetchJson } from '@atlassian/jira-fetch';
import {
	FireOperationalAnalytics,
	FireScreenAnalytics,
	ContextualAnalyticsData,
} from '@atlassian/jira-product-analytics-bridge';
import { useQueryParam } from '@atlassian/jira-router';
import { LicenseFail } from './ui';

export const PolarisUnlicensedApp = () => {
	const [beta] = useQueryParam('beta');
	const [returnTo] = useQueryParam('returnTo');
	const [loading, setLoading] = useState(true);
	const [isBeta, setIsBeta] = useState(false);

	useEffect(() => {
		setLoading(true);
		fetchJson('/rest/polaris/edition')
			.then((editionMetaResponse) => {
				if (beta && !editionMetaResponse?.beta) {
					window.location.href = returnTo?.startsWith('/jira/polaris/projects/')
						? returnTo
						: '/jira/your-work';
				} else {
					setIsBeta(editionMetaResponse?.beta);
					setLoading(false);
				}
			})
			.catch(() => {
				setLoading(false);
			});
	}, [beta, returnTo]);

	if (loading) {
		return null;
	}

	return (
		<ContextualAnalyticsData
			attributes={{
				isBeta,
			}}
		>
			<FireOperationalAnalytics eventName="JpdUnlicensedApp loaded" />
			<FireScreenAnalytics />
			<LicenseFail />
		</ContextualAnalyticsData>
	);
};

export default PolarisUnlicensedApp;
